import { configuratorBuilder } from 'awr-domain'
import { createI18n } from 'awr-i18n'

import SceneEnvironment from './canvas/SceneEnvironment.js'
import { customComponents } from './entity-components/index.js'
import collectFrontendDataHandler from './handlers/collect-frontend-data.js'
import embeddedApplicationWrapperHandler from './shopify/embedded-application-wrapper-handler.js'
import webComponentPropertiesHandler from './shopify/web-component-properties-handler.js'
import {
  changeViewOnBuildNavigation,
  changeViewOnPropertiesNavigation,
  changeViewOnToolStateChange,
  deselectOnNavigation,
  deselectOnToolStateChange,
  fixFixingSystemOnPostStyleChange,
  keepProjectedEntities,
  moveSketchingWhenUpdatingGoingDistance,
  moveSketchingWhenUpdatingNumberOfSteps,
  resetFixingSystemOnPostTypeChange,
  resetFreeWallEndTypeOnPossibleWallFreeEndType,
  resetHandrailTypeOnIncompatiblePostStyle,
  resetThinIntermediatePostsOnMetalPostType,
  resetThinIntermediatePostsOnRoundPostStyle,
  revertBuiltInAutoSelection,
} from './systems/transformers.js'
import { theme } from './theme.js'
import FinalizeAddToCart from './ui/FinalizeAddToCart.js'
import FinalizeEmail from './ui/FinalizeEmail.js'

export const config = configuratorBuilder
  .withComponentOptics(customComponents)
  .withElements([SceneEnvironment])
  .withHandlers([
    FinalizeAddToCart,
    FinalizeEmail,
    embeddedApplicationWrapperHandler,
    webComponentPropertiesHandler,
    collectFrontendDataHandler,
  ])
  .withTheme(theme)
  .withI18n(createI18n())
  .withTransformers(
    [
      { name: 'move-sketching-when-updating-number-of-steps', transformer: moveSketchingWhenUpdatingNumberOfSteps },
      { name: 'move-sketching-when-updating-going-distance', transformer: moveSketchingWhenUpdatingGoingDistance },
      {
        name: 'reset-thin-intermediate-posts-on-metal-post-type',
        transformer: resetThinIntermediatePostsOnMetalPostType,
      },
      {
        name: 'reset-thin-intermediate-posts-on-round-post-style',
        transformer: resetThinIntermediatePostsOnRoundPostStyle,
      },
      {
        name: 'reset-handrail-type-on-incompatible-post-style',
        transformer: resetHandrailTypeOnIncompatiblePostStyle,
      },
      {
        name: 'reset-free-wall-end-type-on-possible-wall-free-end-type',
        transformer: resetFreeWallEndTypeOnPossibleWallFreeEndType,
      },
      { name: 'reset-fixing-system-on-post-type-change', transformer: resetFixingSystemOnPostTypeChange },
      { name: 'keep-projected-entities', transformer: keepProjectedEntities },
      { name: 'deselect-on-navigation', transformer: deselectOnNavigation },
      { name: 'change-view-on-build-navigation', transformer: changeViewOnBuildNavigation },
      { name: 'change-view-on-properties-navigation', transformer: changeViewOnPropertiesNavigation },
      { name: 'deselect-on-tool-state-change', transformer: deselectOnToolStateChange },
      { name: 'change-view-on-tool-state-change', transformer: changeViewOnToolStateChange },
      { name: 'revert-built-in-auto-selection', transformer: revertBuiltInAutoSelection },
      { name: 'fix-fixing-system-on-post-style-change', transformer: fixFixingSystemOnPostStyleChange },
    ],
    [
      { name: 'move-sketching-when-updating-number-of-steps', priority: Infinity },
      { name: 'move-sketching-when-updating-going-distance', priority: Infinity },
      { name: 'reset-thin-intermediate-posts-on-metal-post-type', priority: Infinity },
      { name: 'reset-thin-intermediate-posts-on-round-post-style', priority: Infinity },
      { name: 'reset-handrail-type-on-incompatible-post-style', priority: Infinity },
      { name: 'reset-free-wall-end-type-on-possible-wall-free-end-type', priority: Infinity },
      { name: 'reset-fixing-system-on-post-type-change', priority: Infinity },
      { name: 'keep-projected-entities', priority: Infinity },
      { name: 'deselect-on-navigation', priority: Infinity },
      { name: 'change-view-on-build-navigation', priority: Infinity },
      { name: 'change-view-on-properties-navigation', priority: Infinity },
      { name: 'deselect-on-tool-state-change', priority: Infinity },
      { name: 'change-view-on-tool-state-change', priority: Infinity },
      { name: 'revert-built-in-auto-selection', priority: Infinity },
      { name: 'fix-fixing-system-on-post-style-change', priority: Infinity },
    ]
  )
  .withDefaultEnvs({
    deploymentId: phoenix.runtimeConfig.DEPLOYMENT_ID,
    datadogEnabled: phoenix.runtimeConfig.DATADOG_ENABLED,
    datadogSite: phoenix.runtimeConfig.DATADOG_SITE,
    datadogClientToken: phoenix.runtimeConfig.DATADOG_CLIENT_TOKEN,
    serviceName: phoenix.runtimeConfig.SERVICE_NAME,
    persistenceMode: phoenix.runtimeConfig.PERSISTENCE_MODE,
    serverUrl: phoenix.runtimeConfig.SERVER_URL,
    resourcesUrl: phoenix.runtimeConfig.RESOURCES_URL,
    gtmId: phoenix.runtimeConfig.GTM_ID,
    gtmDebug: phoenix.runtimeConfig.GTM_DEBUG,
  })
  .buildConfig()
